import {RecordPropertyData} from "../types/records-table.types";

export const defaultRecordPropertyData: RecordPropertyData = {
  id: 0
}
